import * as layout from '../../../components/markLayout.module.css';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import type { DripStatus } from '../../../types';
type Props = {
    variant: 'no-draft' | 'existing-draft';
    status: DripStatus;
};
const DraftBanner: React.FC<Props> = ({ variant, status }) => (
    <div
        style={{
            backgroundColor: 'var(--mark-warning-surface)',
            marginBottom: '1rem',
            color: 'var(--mark-warning)'
        }}
        className={layout.panel}
    >
        {variant === 'no-draft' ? (
            <P noDefaultMargin size="small">
                This drip is {status}. Saving will create a new <strong>draft version</strong>. It
                will not go live until you Activate to promote it. Existing instances stay on the
                current version.
            </P>
        ) : (
            <>
                <P noDefaultMargin size="small">
                    You are viewing a draft of a live drip.{' '}
                    <strong>Structural changes are BLOCKED</strong> until a backend fix lands — the
                    current backend replaces this draft with a new version cloned from the ACTIVE
                    version, throwing away every template edit already saved to this draft.
                </P>
                <P
                    noDefaultMargin
                    size="small"
                    styles={{
                        marginTop: '0.4rem'
                    }}
                >
                    Structural Save is disabled. Template edits (via each activity step's "Edit
                    template" button) remain enabled and save straight to this draft.
                </P>
            </>
        )}
    </div>
);
export default DraftBanner;
